module.exports = __webpack_public_path__ + "img/course-success.ff04c207.png";